module.exports = __webpack_public_path__ + "img/8.e75e9246.svg";